import * as React from "react";
import { Typography } from "@mui/material";
import { Todo } from "#common/Todo";
import { PageContainer } from "#pages/PageContainer";

export const About = () => (
    <PageContainer>
        <Typography variant="h1">About</Typography>
        <Todo>
            Add content about the mission, vision, consortium, project,
            consortium and all the rest
        </Todo>
    </PageContainer>
);
